"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/jsx-props-no-spreading */
const react_1 = __importStar(require("react"));
const Atoms_1 = require("../../Atoms");
const themes_1 = require("../../../themes/themes");
const S = __importStar(require("./TextInput.styles"));
const TextInput = ({ assistiveText, label, labelTextBold = false, error = false, success = false, successText, shadow = false, accessibilityLabel, clearButtonEnabled = false, clearButtonClb, onFocus: onFocusClb = () => { }, onBlur: onBlurClb = () => { }, errorIconEnabled = false, errorIcon, maxLength, ...props }) => {
    const [active, setActive] = react_1.useState(false);
    const onFocus = () => {
        setActive(true);
        onFocusClb();
    };
    const onBlur = () => {
        setActive(false);
        onBlurClb();
    };
    const clearInputButtonColor = () => {
        if (error) {
            return themes_1.theme.textInput.error.color;
        }
        if (success) {
            return themes_1.theme.textInput.success.color;
        }
        return themes_1.theme.textInput.clearButtonColor;
    };
    return (react_1.default.createElement(S.TextInputContainer, null,
        react_1.default.createElement(S.LabelContainer, null,
            label && (react_1.default.createElement(S.Label, { accessibilityLabel: accessibilityLabel, accessibilityRole: "text", bold: labelTextBold, testID: accessibilityLabel }, label)),
            (label || assistiveText) && react_1.default.createElement(S.LabelFiller, null),
            assistiveText && (react_1.default.createElement(S.AssistiveText, { accessibilityRole: "text" }, assistiveText))),
        react_1.default.createElement(S.StyledTextWrapper, null,
            react_1.default.createElement(S.StyledTextInput, Object.assign({ maxLength: maxLength, clearButtonEnabled: clearButtonEnabled, errorIconEnabled: errorIconEnabled, error: !!error, success: success, active: active, shadow: shadow, accessible: true, accessibilityLabel: `Enter ${accessibilityLabel}`, testID: `Enter ${accessibilityLabel}`, onFocus: onFocus, onBlur: onBlur }, props)),
            clearButtonEnabled && (react_1.default.createElement(S.ClearInputButton, { onPress: clearButtonClb, testID: "Clear", accessibilityLabel: "Clear" },
                react_1.default.createElement(Atoms_1.CloseIcon, { width: "16px", height: "16px", color: clearInputButtonColor() }))),
            error && errorIconEnabled && !clearButtonEnabled && (react_1.default.createElement(S.ErrorIconContainer, { testID: "ErrorIcon" }, errorIcon ? errorIcon() : react_1.default.createElement(Atoms_1.Exclamation, null)))),
        ((error && typeof error === 'string') || (success && successText)) && (react_1.default.createElement(S.LabelContainer, null,
            react_1.default.createElement(Atoms_1.ErrorLabel, { status: error ? 'error' : 'success', testID: "ErrorLabel" }, error || successText)))));
};
exports.default = TextInput;
